import { render } from "./BenefitConfigs.vue?vue&type=template&id=579466b6"
import script from "./BenefitConfigs.vue?vue&type=script&lang=js"
export * from "./BenefitConfigs.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__